import React from "react";

// Safety net so an unexpected render crash (e.g. missing/unexpected API field on some
// edge-case account) shows a clear recoverable message instead of a fully blank page.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught a render error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="app-error-boundary"
          className="min-h-screen flex items-center justify-center bg-slate-950 text-center px-6"
        >
          <div>
            <p className="text-lg font-bold text-white mb-2">Something went wrong.</p>
            <p className="text-sm text-slate-400 mb-6">Please reload the page. If the problem continues, contact support.</p>
            <button
              data-testid="app-error-boundary-reload-button"
              onClick={() => window.location.reload()}
              className="px-5 py-2.5 rounded-full bg-primary text-white text-sm font-bold"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
